module.exports = __webpack_public_path__ + "img/userPizzarraAZ.e918a355.svg";